<template>
  <div class="hero"
       :style="{'background-image': background ? `url(${background})` : ''}"
       :class="{'default-bg': !background, 'has-video': videoSrc}">
    <div v-if="videoSrc" class="video-container">
      <div class="video-overlay"></div>
      <video :src="videoSrc" autoplay muted playsinline loop="loop"></video>
    </div>
    <div class="container">
      <div class="row">
        <div class="col-12">
          <slot></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HeroSmall',
  props: {
    background: null,
    videoSrc: null,
  },
};
</script>

<style scoped lang="scss">
@import '@/assets/scss/common.scss';
.hero {
  background-size: cover;
  background-position: center;
  -webkit-print-color-adjust: exact;
  color-adjust: exact;
  padding: 90px 0;
  position: relative;
  &.default-bg:not(.has-video) {
    background-image: url('../assets/hero.jpg')!important;
    background-position: center top;
  }
  &:not(.default-bg) {
    position: relative;
    &::before {
      content: '';
      position: absolute;
      left: 0; top: 0;
      width: 100%;
      height: 100%;
      background: linear-gradient(180deg,hsla(0,0%,100%,0),rgba(0,74,128,.7));
    }
  }
  h1 {
    margin-bottom: .3em;
  }
  p {
    font-size: 20px;
    margin: 0;
  }
  @include media-breakpoint-down(lg) {
    h1 {
      font-size: 30px;
    }
    p {
      font-size: 16px;
    }
  }
  .video-container {
    position: absolute;
    left: 0; top: 0;
    width: 100%;
    height: 100%;
    .video-overlay {
      position: absolute;
      left: 0; top: 0;
      width: 100%;
      height: 100%;
      background: linear-gradient(180deg,hsla(0,0%,100%,0),rgba(0,74,128,.7));
    }
    video {
      height: 100%;
      width: 100%;
      object-fit: cover;
    }
  }
}
</style>
